<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-container fluid>
      <b-card class="bCardGlobal">
        <b-row class="titulo">
          <b-col class="seccionTitulo">
            <span
              ><b-icon icon="file-earmark-check" aria-hidden="true"></b-icon
            ></span>
            <span>MSI </span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>CONF_MSI</div>
          </b-col>
        </b-row>
  
        <div class="divSubtitulo">
          <p class="textSubtitulo">Montos MSI</p>
        </div>

        <b-tabs class="mt-4" content-class="mt-3">
          <b-tab title="MSI" active>
            <b-row class="mt-3">
              <b-col>
                <b-row align-v="center" align-h="end">
                  <b-col align="right">
                    <b-button v-b-tooltip.hover title="Crear menú" variant="outline-success"
                              @click="agregar()"
                    >Crear MSI
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
      
            <b-row class="mt-3">
              <b-col cols="12">
                <b-table
                    thead-tr-class="columnas"
                    :items="listaMSI"
                    :fields="campos"
                    fixed
                >
                  <template v-slot:cell(montoInicial)="row">
                    <p v-if="!editar">{{ row.item.montoInicial | moneda }}</p>
                  </template>
                  <template v-slot:cell(montoFinal)="row">
                    <p v-if="!editar">{{ row.item.montoFinal | moneda }}</p>
                  </template>
                  <template v-slot:cell(registroActivo)="row">
                    <p v-if="row.item.registroActivo">Activo</p>
                    <p v-else>Inactivo</p>
                  </template>
                  <template v-slot:cell(acciones)="row">
                    <b-button-group>
                      <b-button
                          title="Modificar Tipo de Solicitud"
                          size="sm"
                          variant="outline-warning"
                          @click="modificar(row.item)"
                      ><em class="fa fa-pencil"></em></b-button>
                      <b-button
                          v-if="!row.item.registroActivo"
                          title="Activar tipo solicitud"
                          variant="outline-success"
                          size="sm"
                          @click="cambiarEstatusMsi(row.item)"
                      ><em class="fa fa-undo"></em></b-button>
                      <b-button v-else
                                title="Desactivar tipo solicitud"
                                variant="outline-danger"
                                size="sm"
                                @click="cambiarEstatusMsi(row.item)"
                      >
                        <b-icon icon="trash-fill"></b-icon>
                      </b-button>
                    </b-button-group>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            
          
          </b-tab>
          <b-tab title="Afiliación">
            <BancoAfiliacion ></BancoAfiliacion>
          </b-tab>
          
        </b-tabs>

     

    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label>Nombre
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="descripcion" name="descripcion" placeholder="Nombre"
                                v-model="$v.msi.detalleForma.$model"
                                :state="validateState('detalleForma')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label>Monto Inicial
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="cash-stack"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="nivel" name="nivel" placeholder="Monto inicial"
                                v-model="$v.msi.montoInicial.$model" type="number"
                                :state="validateState('montoInicial')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label>Monto Final
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="cash-stack"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="nivel" name="nivel" placeholder="Monto final"
                                v-model="$v.msi.montoFinal.$model" type="number"
                                :state="validateState('montoFinal')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>

    </b-card>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import VueNotifications from "vue-notifications";
import {required} from "vuelidate/lib/validators";
import BancoAfiliacion from "./BancoAfiliacion";

export default {
  name: "CambioMSI",
  components: {
    Header,
    BancoAfiliacion
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    listaMSI: [],
    campos: [
      {
        key: "detalleForma",
        label: "Nombre",
      },
      {
        key: "montoInicial",
        label: "Monto inicial",
      },
      {
        key: "montoFinal",
        label: "Monto final",
      },
      {
        key: "registroActivo",
        label: "Estatus",
      },
      {
        key: "acciones",
        label: "Acciones",
      },
    ],
    editar: false,
    cargando: true,
    enviando: false,
    msi: {
      idFormaPagoDetalle: null,
      detalleForma: null,
      montoInicial: null,
      montoFinal: null,
      registroActivo: null,
    },
    tituloModal: '',
    loaderAcciones: false,
    show: false,
  }),
  validations: {
    msi: {
      detalleForma:{required},
      montoInicial: {required},
      montoFinal: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.traerMSI();
  },
  methods: {
    agregar() {
      this.msi = {
        idFormaPagoDetalle: null,
        detalleForma: null,
        montoInicial: null,
        montoFinal: null,
        registroActivo: null,
      };
      this.tituloModal = 'Agregar MSI';
      this.show = true;
    },
    modificar(item) {
      this.msi = item;
      this.tituloModal = 'Modificar MSI';
      this.show = true;
    },
    guardar(){
      this.$v.msi.$touch();
      if (this.$v.msi.$anyError) {
        return;
      }
      if (!this.$v.msi.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'forma/guardar/msi', this.msi).then(respuesta => {
              if (respuesta.data.data) {
                this.traerMSI();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El MSI se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    traerMSI() {
      const url = this.$api + "forma/msi";

      this.$http
        .get(url)
        .then((response) => {
          this.listaMSI = response.data.data.formas;
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    guardarMonto() {
      this.enviando = true;
      const url = this.$api + "forma/msi/montos";

      this.$http
        .put(url, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .catch((err) => {
          this.errorEnvio(err);
        })
        .finally(() => {
          this.enviando = false;
          this.cargando = true;
          this.traerMSI();
        });
    },
    traerDatos() {
      let lista = [];
      this.listaMSI.forEach((element) => {
        let datos = {
          idFormaPagoDetalle: element.idFormaPagoDetalle,
          montoFinal: element.montoFinal,
          montoInicial: element.montoInicial,
          usuarioLogeado: this.$localStorageService.getIdUsuario(),
        };
        lista.push(datos);
      });

      return lista;
    },
    cambiarEstatusMsi(msi) {
      const url = this.$api + "forma/msi";
      const parametros = {
        idFormaPagoDetalle: msi.idFormaPagoDetalle,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
      };

      this.$http
        .put(url, parametros)
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Datos guardados correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .catch((err) => {
          this.errorEnvio(err);
        })
        .finally(() => {
          this.cargando = true;
          this.traerMSI();
        });
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.msi[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    }

  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>
